import { createSelector } from 'reselect'
import { getCurrency, getMarkupType } from './settings'
import { jewelryPriceHelper } from './prices'

const getCurrentJewelry = state => state.jewelrySearch.result
const getJewelryModalRow = state => state.jewelrySearch.modalRow

export const getCurrentJewelryPrice = createSelector(
  [getCurrentJewelry, getMarkupType, getCurrency],
  (jewelry, markup, currency) => jewelryPriceHelper(jewelry, markup, currency)
)

export const getJewelryModalPrice = createSelector(
  [getJewelryModalRow, getMarkupType, getCurrency],
  (jewelry, markup, currency) => {
    return jewelryPriceHelper(jewelry, markup, currency)
  }
)



// WEBPACK FOOTER //
// ./src/selectors/jewelry-search.js